
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thiruvananthapuram",
      function () {
        return require("private-next-pages/thiruvananthapuram/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thiruvananthapuram"])
      });
    }
  